import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfPartnerRequestDetail } from "./types";

// Reads a single MDF request detail (any status, partner-scoped). The
// detail page branches on `data.request.status`: draft → editable runtime
// view (which independently fetches /drafts/:id for the allocation-balance
// shape); everything else → read-only view rendered from this payload.
export function useMdfRequestDetail(requestId: string | null) {
  return useQuery<MdfPartnerRequestDetail>({
    queryKey: queryKeys.mdf.request(requestId ?? ""),
    queryFn: () =>
      apiFetch<MdfPartnerRequestDetail>(`/portal/mdf/requests/${requestId}`),
    enabled: !!requestId,
  });
}
